import React, { useState, useEffect, useContext } from 'react';
import Form from 'react-bootstrap/Form';
import styled from 'styled-components';
import Boton from '../eventos/navegacion_y_accion/Boton';
import Titulo from "../basicos/Titulo";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { ToastContainer, toast } from "react-toastify";
import { useParams } from "react-router-dom";
import Button from 'react-bootstrap/Button';
import { Trash2, Building2 } from 'lucide-react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { RiOrganizationChart } from "react-icons/ri";
import { ChromePicker } from 'react-color';
import ImagenDefault from './../../img/imgDefault.png';
import IconosGenerales from "../../elementos/iconos/IconosGenerales";

import { handleChangeErrors, handleSubmitErrorsEmpresas, todosDatosCorrectos } from '../../validacion/ValidationFormEmpresa';
import { fetchEditarNegocio, fetchNegocioData } from '../../../peticiones_API/PeticionesGestionPersonasNegocios';
import { fetchAsesoriasOrganigrama, saveAsesoriasOrganigrama } from '../../../peticiones_API/PeticionesOrganigrama';
import { DatosCorrectosEmpresa, ServerNoCreoEmpresa, DatosIncorrectos } from '../eventos/avisos/VentanaEmergente';
import ErrorForm from '../eventos/avisos/Alerta';
import { UsuarioContext } from '../../providers/personaContext';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ pt: 3 }}>
            {children}
          </Box>
        )}
      </div>
    );
}


const FormEditarNegocio = ({ departamentos }) => {

    const { persona } = useContext(UsuarioContext);
    const esSuperAdmin = persona?.rol === 'super administrador';

    let departamentosInternos = departamentos.filter(departamento => departamento.tipo === 'interno').sort((a, b) => a.nombre.localeCompare(b.nombre));
    let departamentosOrganigrama = departamentos.filter(departamento => departamento.tipo === 'organigrama').sort((a, b) => a.nombre.localeCompare(b.nombre));
    console.log("departamentosInternos: ", departamentosInternos);
    console.log("departamentosOrganigrama: ", departamentosOrganigrama);
    console.log("departamentos: ", departamentos);

    const { Id } = useParams();
    const API_URL = process.env.REACT_APP_API_URL;
    const [negocioData, setNegocioData] = useState({ id: Id });
    const [formCompletado, setFormCompletado] = useState(null);
    const [estadosActualizados, setEstadosActualizados] = useState(false);
    const [filas, setFilas] = useState([]);
    // Asesorías del organigrama (N:M con sentido entre departamentos del negocio).
    // Cada fila aquí guarda { asesor_de_id, asesorado_de_id, nota }.
    const [asesorias, setAsesorias] = useState([]);
    const [errorEnviarForm, setErrorEnviarForm] = useState({ negocioDuplicado: null });
    const [previsualizacionImg, setPrevisualizacionImg] = useState(null);
    const [mostrarColorPicker, setMostrarColorPicker] = useState(false);
    const [tabValue, setTabValue] = useState(0);
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    const camposRequeridos = { 
        nombre: "Debes insertar un nombre",
        color: "Debes seleccionar un color"
    };
    const [estadoCampoReque, setEstadoCampoReque] = useState({ 
        nombre: null,
        color: null
    });

     const [botonRenderClick, setBotonRenderClick] = useState(false);

    const handleChange = (event) => {

        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo

        const { name, value, type, files } = event.target;
        
        let newValue;
        if (type === 'file') {
            newValue = files[0];
        } else {
            newValue = value;
        }
        
        setNegocioData(prev => ({ ...prev, [name]: newValue }));
        
        if (type === 'file' && files[0]) {
            const file = files[0];
            const reader = new FileReader();
            
            if (name === 'logoEmpresa_img') {
                reader.onloadend = () => {
                    setPrevisualizacionImg(reader.result);
                };
                reader.readAsDataURL(file);
            }
        }
        
        if (name in estadoCampoReque) {
            handleChangeErrors(name, value, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
        }
    };

    const handleColorChange = (color) => {
        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo
        
        setNegocioData(prev => ({ ...prev, color: color.hex }));
        handleChangeErrors('color', color.hex, estadoCampoReque, setEstadoCampoReque, setEstadosActualizados);
    };

    const handleDelete = () => {
        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo

        setPrevisualizacionImg(null);
        document.getElementById("logoEmpresa_img").value = "";
        delete negocioData.logo;
        setNegocioData(prevData => ({ ...prevData, logo: null, imagen_base64: null }));
    };

    const agregarFila = () => {
        const tipo = tabValue === 0 ? 'interno' : 'organigrama';
        // Para organigrama, además del legacy dependencia_id/mando_intermedio_de
        // introducimos un selector unificado: vinculo_tipo ∈ {'cuelga','mando','asistente'}
        // y vinculo_destino. La traducción a los 3 FK del backend (uno con valor,
        // dos a NULL) se hace en el guardado.
        setFilas([...filas, {
            departamento: '',
            dependencia_id: '',
            tipo,
            mando_intermedio_de: [],
            vinculo_tipo: 'cuelga',
            vinculo_destino: '',
        }]);
    };

    // Asesorías ── add/remove/cambio inline
    const agregarAsesoria = () => {
        setAsesorias((prev) => [...prev, { asesor_de_id: '', asesorado_de_id: '', nota: '' }]);
    };
    const eliminarAsesoria = (idx) => {
        setAsesorias((prev) => prev.filter((_, i) => i !== idx));
    };
    const cambiarAsesoria = (idx, campo, valor) => {
        setAsesorias((prev) => prev.map((r, i) => i === idx ? { ...r, [campo]: valor } : r));
    };

    const eliminarFila = (index) => {
        const departamentoEliminado = filas[index].departamento;
        
        const nuevasFilas = filas.filter((_, i) => i !== index);
        
        if (departamentoEliminado) {
            let dependenciasLimpiadas = 0;
            nuevasFilas.forEach(fila => {
                if (fila.dependencia_id == departamentoEliminado) {
                    fila.dependencia_id = null;
                    dependenciasLimpiadas++;
                }
            });
        }
        
        setFilas(nuevasFilas);
    };

    const handleChangeFila = (index, campo, valor) => {
        setFormCompletado(null); // Reiniciar el estado de formCompletado al cambiar cualquier campo

        const nuevasFilas = [...filas];
        if (valor == '' || valor == null)
            nuevasFilas[index][campo] = null;
        else
            nuevasFilas[index][campo] = parseInt(valor);

        setFilas(nuevasFilas);
    };

    const getDepartamentosPorEmpresa = (index) => {
        const currentDeptId = filas[index].departamento?.toString();
        
        if (!currentDeptId) return [];
        
        const findDependentDepts = (deptId, visited = new Set()) => {
            if (visited.has(deptId)) return;
            visited.add(deptId);
            
            filas.forEach(fila => {
                if (fila.dependencia_id?.toString() === deptId) {
                    const childDeptId = fila.departamento?.toString();
                    if (childDeptId) {
                        findDependentDepts(childDeptId, visited);
                    }
                }
            });
            
            return visited;
        };
        
        const deptsThatDependOnCurrent = findDependentDepts(currentDeptId);
        
        const availableDepts = [];
        
        filas.forEach(fila => {
            if (fila.departamento && 
                fila.departamento.toString() !== currentDeptId && 
                !deptsThatDependOnCurrent.has(fila.departamento.toString())) {
                
                const deptObj = departamentos.find(d => d.Id.toString() === fila.departamento.toString());
                if (deptObj) availableDepts.push(deptObj);
            }
        });
        
        
        return availableDepts;
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if(event.target.name === "guardar_cambios_statico"){
            setBotonRenderClick(false);
        }else{         
            setBotonRenderClick(true);
        }

        handleSubmitErrorsEmpresas(
            negocioData,
            estadoCampoReque,
            setEstadoCampoReque,
            camposRequeridos,
            setEstadosActualizados
        );

        setEstadosActualizados(true);
    };
  
    useEffect(() => {
        const fetchData = async () => {
            try {
                const negocio = await fetchNegocioData(Id);
                setNegocioData(negocio);
                
                if (negocio.logo) {
                    const urlPrevisualizacion = `/api/negocio/logo/${negocio.logo}?t=${Date.now()}`;
                    setPrevisualizacionImg(`${API_URL}${urlPrevisualizacion}` || null);
                }
                
                if (negocio.Departamentos && negocio.Departamentos.length > 0) {
                    const filasIniciales = negocio.Departamentos.map(dep => {
                        const de = dep.DepartamentoEmpresa;
                        // Deriva vinculo_tipo/vinculo_destino desde los 3 FK del backend.
                        // Prioridad explícita asistente > mando > dependencia, alineada
                        // con la regla XOR del save: solo uno tendrá valor real.
                        let vinculo_tipo = 'cuelga';
                        let vinculo_destino = '';
                        if (de?.asistente_de && de?.asistente_info) {
                            vinculo_tipo = 'asistente';
                            vinculo_destino = de.asistente_info.id;
                        } else if (de?.mando_intermedio_de_1 && de?.mando_intermedio_info_1) {
                            vinculo_tipo = 'mando';
                            vinculo_destino = de.mando_intermedio_info_1.id;
                        } else if (de?.dependencia_id && de?.dependencia_info) {
                            vinculo_tipo = 'cuelga';
                            vinculo_destino = de.dependencia_info.id;
                        }
                        return {
                            departamento: dep.Id,
                            dependencia_id: de?.dependencia_id ? de.dependencia_info.id : '',
                            tipo: dep.tipo || 'interno',
                            mando_intermedio_de: de?.mando_intermedio_info_1 ? de.mando_intermedio_info_1.id : '',
                            vinculo_tipo,
                            vinculo_destino,
                        };
                    });
                    setFilas(filasIniciales);
                }

                // Cargar asesorías del negocio (catálogo aparte, N:M dirigido).
                try {
                    const arr = await fetchAsesoriasOrganigrama(Id);
                    if (Array.isArray(arr)) {
                        // En estado guardamos por departamento_id (más natural para el
                        // selector que muestra departamentos del negocio). La conversión
                        // a DepartamentoEmpresa.id ocurre al guardar.
                        setAsesorias(arr.map(r => ({
                            asesor_de_id:    r.asesor_departamento_id    || '',
                            asesorado_de_id: r.asesorado_departamento_id || '',
                            nota: r.nota || '',
                        })));
                    }
                } catch (_) { /* silencioso: el form sigue sin asesorías cargadas */ }
            } catch (error) {
                console.log("Ha habido un error:", error);
            }
        };

        fetchData();
    }, [Id]);

    useEffect(() => {
        const imgInput = document.getElementById("logoEmpresa_img");
        const valorImg = imgInput ? imgInput.value : "";

        if ((negocioData.logo == null || negocioData.logo == "") && (valorImg != "")) {
            const logo = `${Id}_empresa_img`;
            setNegocioData(prevFormData => ({ ...prevFormData, logo: logo }));
        }

        if (estadosActualizados) {
            // Consumimos el flag inmediatamente: el envío se dispara UNA vez
            // por clic de Guardar. Sin este reset, cualquier cambio posterior
            // en `filas` (al elegir Departamento / Tipo / Destino) re-disparaba
            // este useEffect — y por tanto guardaba en cada selección.
            setEstadosActualizados(false);
            const validacionTodosDatos = todosDatosCorrectos(negocioData, estadoCampoReque);
            const todosCamposFalse = validacionTodosDatos.todosCamposFalse();
            (async () => {
                if (todosCamposFalse === true) {
                    setFormCompletado(true);
                    setErrorEnviarForm({ negocioDuplicado: false });

                    try {

                        // Traducir vinculo_tipo + vinculo_destino al trío de FK que
                        // espera el backend. Garantizamos en cliente que solo uno
                        // tendrá valor — el backend además aplica XOR como red de
                        // seguridad. Solo aplica a filas de organigrama (tabValue 1);
                        // las internas siguen usando dependencia_id como antes.
                        const filasParaEnviar = filas.map((f) => {
                            if (f.tipo !== 'organigrama') {
                                if (f.dependencia_id === '' || !f.dependencia_id) {
                                    return { ...f, dependencia_id: null };
                                }
                                return f;
                            }
                            const tipo = f.vinculo_tipo || 'cuelga';
                            const destino = f.vinculo_destino || null;
                            const base = { ...f, dependencia_id: null, mando_intermedio_de: null, asistente_de: null };
                            if (tipo === 'asistente' && destino) base.asistente_de = destino;
                            else if (tipo === 'mando' && destino) base.mando_intermedio_de = destino;
                            else if (tipo === 'cuelga') base.dependencia_id = destino || null;
                            return base;
                        });

                        const formData = new FormData();

                        formData.append('Id', negocioData.Id);
                        formData.append('nombre', negocioData.nombre);
                        formData.append('color', negocioData.color);
                        formData.append('colaborador', negocioData.colaborador === true);
                        formData.append('vacaciones', negocioData.vacaciones !== false);

                        // Agregar imagen si existe
                        if (negocioData.logoEmpresa_img)
                            formData.append('logoEmpresa_img', negocioData.logoEmpresa_img);
                        else if (negocioData.logo == null)
                            formData.append('logoEmpresa_img', "");

                        // Agregar departamentos como JSON
                        formData.append('Departamentos', JSON.stringify(filasParaEnviar));

                        await fetchEditarNegocio(formData);

                        // Asesorías: el endpoint espera ids de DepartamentoEmpresa.
                        // Hacemos el mapeo departamento_id → DepartamentoEmpresa.id
                        // consultando el negocio recién guardado (el endpoint
                        // editarNegocio crea las DepartamentoEmpresa que faltaran).
                        try {
                            const negocioActual = await fetchNegocioData(Id);
                            const mapDeptToDeptEmp = new Map();
                            (negocioActual?.Departamentos || []).forEach((d) => {
                                const deId = d.DepartamentoEmpresa?.id;
                                if (deId) mapDeptToDeptEmp.set(d.Id, deId);
                            });
                            const asesoriasPayload = asesorias
                                .filter(a => a.asesor_de_id && a.asesorado_de_id && a.asesor_de_id !== a.asesorado_de_id)
                                .map(a => ({
                                    asesor_de_id:    mapDeptToDeptEmp.get(Number(a.asesor_de_id)),
                                    asesorado_de_id: mapDeptToDeptEmp.get(Number(a.asesorado_de_id)),
                                    nota: a.nota || null,
                                }))
                                .filter(a => a.asesor_de_id && a.asesorado_de_id);
                            await saveAsesoriasOrganigrama(Id, asesoriasPayload);
                        } catch (e) {
                            // No bloquea: el negocio ya se guardó. Solo logueamos.
                            console.warn('Fallo al guardar asesorías:', e?.message);
                        }
                    } catch (error) {
                        if (error?.response?.data?.error === 'REGISTRO_DUPLICADO') {
                            setErrorEnviarForm({ negocioDuplicado: true });
                        }
                        setFormCompletado(false);
                    }
                } else {
                    toast.error("Faltan campos por rellenar");
                }
            })();
        }
    }, [estadosActualizados, negocioData, estadoCampoReque, filas]);

    return (
        <>
            <Form>
                <CabeceraForm>
                    <Titulo texto="EDITAR UN NEGOCIO" />
                </CabeceraForm>
                <Container>  
                    <ToastContainer />
                    <TituloSeccion className='mb-12'>INFORMACIÓN GENERAL</TituloSeccion>
                    <Row md="3" className="align-items-end mb-3">
                            <Form.Group className="mb-12">
                                <TituloCategoria>Nombre <span>*</span></TituloCategoria>
                                <Form.Control
                                    type="text"
                                    name="nombre"
                                    className="py-3"
                                    value={negocioData.nombre || ''}
                                    onChange={handleChange}
                                />
                                <ErrorForm mensaje={camposRequeridos.nombre} estadoAlerta={estadoCampoReque.nombre} />
                            </Form.Group>
                            
                            <Form.Group className="mb-12">
                                <TituloCategoria>Color <span>*</span></TituloCategoria>
                                <div style={{ position: 'relative' }}>
                                    <div 
                                        style={{
                                            padding: '11px',
                                            background: '#fff',
                                            borderRadius: '4px',
                                            border: '1px solid #ced4da',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '10px'
                                        }}
                                        onClick={() => setMostrarColorPicker(!mostrarColorPicker)}
                                    >
                                        <div style={{
                                            width: '36px',
                                            height: '36px',
                                            borderRadius: '4px',
                                            background: negocioData.color || '#ffffff',
                                            border: '1px solid #ccc'
                                        }} />
                                        <span>{negocioData.color || 'Seleccionar color'}</span>
                                    </div>
                                    {mostrarColorPicker && (
                                        <div style={{ position: 'absolute', zIndex: 2, marginTop: '5px' }}>
                                            <div 
                                                style={{
                                                    position: 'fixed',
                                                    top: '0px',
                                                    right: '0px',
                                                    bottom: '0px',
                                                    left: '0px'
                                                }}
                                                onClick={() => setMostrarColorPicker(false)}
                                            />
                                            <ChromePicker 
                                                color={negocioData.color || '#ffffff'}
                                                onChange={handleColorChange}
                                            />
                                        </div>
                                    )}
                                </div>
                                <ErrorForm mensaje={camposRequeridos.color} estadoAlerta={estadoCampoReque.color} />
                            </Form.Group>

                            {esSuperAdmin && (
                            <Form.Group className="mb-12" style={{ alignSelf: 'flex-start' }}>
                                <TituloCategoria>Tipo de Negocio</TituloCategoria>
                                <div style={{ transform: 'scale(1.4)', marginLeft: '70px', marginTop: '15px' }}>
                                    <Form.Check
                                        type="checkbox"
                                        id="colaborador"
                                        label="Colaborador"
                                        checked={negocioData.colaborador === true}
                                        onChange={e => {
                                            setFormCompletado(null);
                                            setErrorEnviarForm({ negocioDuplicado: null });
                                            setNegocioData(prev => ({
                                                ...prev,
                                                colaborador: e.target.checked
                                            }));
                                        }}
                                    />
                                    <Form.Check
                                        type="checkbox"
                                        id="vacaciones"
                                        label="Vacaciones"
                                        checked={negocioData.vacaciones !== false}
                                        disabled={!negocioData.colaborador}
                                        onChange={e => {
                                            setFormCompletado(null);
                                            setErrorEnviarForm({ negocioDuplicado: null });
                                            setNegocioData(prev => ({
                                                ...prev,
                                                vacaciones: e.target.checked
                                            }));
                                        }}
                                        style={{ marginTop: '10px' }}
                                    />
                                </div>
                            </Form.Group>
                            )}
                    </Row>

                    <TituloSeccion className='mb-12'>LOGO DEL NEGOCIO</TituloSeccion>
                    <Row className="mt-4 mb-4">
                        <Col>
                            {previsualizacionImg ? (
                                <div>
                                    <TituloCategoria>Vista previa del logo:</TituloCategoria>
                                    <ContenedorEncabezado>
                                        <IconosGenerales
                                            alerta="true"
                                            id="delete"
                                            onClick={handleDelete}
                                        />
                                        <img 
                                            src={previsualizacionImg} 
                                            onError={(e) => {
                                                setNegocioData(prevData => ({ ...prevData, logo: null, imagen_base64: null }));
                                                setPrevisualizacionImg(null);
                                            }}
                                            alt="Vista previa"
                                            style={{
                                                maxWidth: '100%',
                                                maxHeight: '250px',
                                                minHeight: '200px',
                                                width: 'auto',
                                                height: 'auto',
                                                objectFit: 'contain',
                                                display: 'block',
                                                margin: '0 auto'
                                            }} 
                                        />
                                    </ContenedorEncabezado>
                                </div>
                            ) : (
                                <div>
                                    <TituloCategoria>Vista previa del logo:</TituloCategoria>
                                    <img 
                                        src={ImagenDefault} 
                                        alt="Vista previa" 
                                        style={{ 
                                            maxWidth: '100%', 
                                            maxHeight: '250px',
                                            minHeight: '200px',
                                            width: 'auto', 
                                            height: 'auto', 
                                            objectFit: 'contain',
                                            display: 'block',
                                            margin: '0 auto' 
                                        }} 
                                    />
                                </div>
                            )}
                        </Col>
                        <Col>
                            <Form.Group className="mb-3 mt-10">
                                <TituloCategoria>Adjuntar logo del Negocio</TituloCategoria>
                                <Form.Control 
                                    type="file" 
                                    id='logoEmpresa_img' 
                                    accept=".jpg,.jpeg,.png,.webp" 
                                    max-file-size="3072"
                                    name="logoEmpresa_img" 
                                    onChange={handleChange} 
                                />
                            </Form.Group>
                        </Col>
                    </Row>

                    <TituloSeccion className='mb-12'>DEPARTAMENTOS</TituloSeccion>

                    <Row className="align-items-end mb-3">
                    
                        {/* Tabs de navegación */}
                        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <Tabs value={tabValue} onChange={handleTabChange} aria-label="Pestañas de formulario" left>
                                <Tab 
                                    label="Interno" 
                                    icon={<Building2 size={20} />} 
                                />
                                <Tab 
                                    label="Organigrama"
                                    icon={<RiOrganizationChart size={20} />}
                                />
                            </Tabs>
                        </Box>

                        <TabPanel value={tabValue} index={0}>
                            <Col md={2} className="text-center">
                                <Boton
                                    bonificados="true"
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    onClick={agregarFila}
                                    form="true"
                                >
                                    + Añadir Fila
                                </Boton>
                            </Col>

                            {/* Solo filas de tipo 'interno' */}
                            {filas.filter(fila => fila.tipo === 'interno').map((fila, index) => {
                                const realIndex = filas.filter(f => f.tipo === 'interno').findIndex(f => f === fila);
                                return (
                                    <Row className="mb-3" key={realIndex}>
                                        <Col md={5}>
                                            <Form.Group>
                                                <TituloCategoria>Departamento {realIndex + 1}</TituloCategoria>
                                                <Form.Select
                                                    value={fila.departamento}
                                                    className="py-3"
                                                    onChange={(e) => handleChangeFila(filas.findIndex(f => f === fila), 'departamento', e.target.value)}
                                                >
                                                    <option value=""></option>
                                                    {departamentosInternos
                                                        .filter(dep => {
                                                            const selectedDepts = filas
                                                                .filter((f, i) => i !== filas.findIndex(f2 => f2 === fila) && f.tipo === 'interno')
                                                                .map(f => f.departamento?.toString());
                                                            return !selectedDepts.includes(dep.Id.toString());
                                                        })
                                                        .map((dep) => (
                                                            <option key={dep.Id} value={dep.Id}>
                                                                {dep.nombre}
                                                            </option>
                                                        ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={5}>
                                            <Form.Group>
                                                <TituloCategoria>Dependencia {realIndex + 1}</TituloCategoria>
                                                <Form.Select
                                                    value={fila.dependencia_id}
                                                    className="py-3"
                                                    onChange={(e) => handleChangeFila(filas.findIndex(f => f === fila), 'dependencia_id', e.target.value)}
                                                >
                                                    <option value=""></option>
                                                    {getDepartamentosPorEmpresa(filas.findIndex(f => f === fila)).filter(dep => dep.tipo === 'interno').map((departamento) => (
                                                        <option key={departamento.Id} value={departamento.Id}>
                                                            {departamento.nombre}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col xs="auto" className="d-flex align-items-center" style={{ paddingTop: '35px' }}>
                                            <Button variant="danger"
                                                onClick={() => eliminarFila(filas.findIndex(f => f === fila))}
                                                style={{ height: '50px', width: '50px' }}>
                                                <Trash2 />
                                            </Button>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </TabPanel>
                        <TabPanel value={tabValue} index={1}>
                            <Col md={2} className="text-center">
                                <Boton
                                    bonificados="true"
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    onClick={agregarFila}
                                    form="true"
                                >
                                    + Añadir Fila
                                </Boton>
                            </Col>
                            {/* Solo filas de tipo 'organigrama' */}
                            {filas.filter(fila => fila.tipo === 'organigrama').map((fila, index) => {
                                const realIndex = filas.filter(f => f.tipo === 'organigrama').findIndex(f => f === fila);
                                const globalIndex = filas.findIndex(f => f === fila);
                                return (
                                    <Row className="mb-3" key={realIndex}>
                                        <Col md={3}>
                                            <Form.Group>
                                                <TituloCategoria>Departamento {realIndex + 1}</TituloCategoria>
                                                <Form.Select
                                                    value={fila.departamento}
                                                    className="py-3"
                                                    onChange={(e) => handleChangeFila(globalIndex, 'departamento', e.target.value)}
                                                >
                                                    <option value=""></option>
                                                    {departamentosOrganigrama
                                                        .filter(dep => {
                                                            const selectedDepts = filas
                                                                .filter((f, i) => i !== globalIndex && f.tipo === 'organigrama')
                                                                .map(f => f.departamento?.toString());
                                                            return !selectedDepts.includes(dep.Id.toString());
                                                        })
                                                        .map((dep) => (
                                                            <option key={dep.Id} value={dep.Id}>
                                                                {dep.nombre}
                                                            </option>
                                                        ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group>
                                                <TituloCategoria>Tipo de vínculo {realIndex + 1}</TituloCategoria>
                                                <Form.Select
                                                    className="py-3"
                                                    value={fila.vinculo_tipo || 'cuelga'}
                                                    onChange={(e) => {
                                                        // Cambiar el tipo reinicia el destino (excepto cuelga, que
                                                        // admite vacío = raíz). Evita estados inconsistentes.
                                                        setFormCompletado(null);
                                                        setFilas((prev) => prev.map((f, i) => i === globalIndex
                                                            ? { ...f, vinculo_tipo: e.target.value, vinculo_destino: '' }
                                                            : f));
                                                    }}
                                                >
                                                    <option value="cuelga">Cuelga de</option>
                                                    <option value="mando">Mando intermedio de</option>
                                                    <option value="asistente">Asistente de</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group>
                                                <TituloCategoria>
                                                    Destino {realIndex + 1}
                                                    {fila.vinculo_tipo !== 'cuelga' && <span> *</span>}
                                                </TituloCategoria>
                                                <Form.Select
                                                    className="py-3"
                                                    value={fila.vinculo_destino || ''}
                                                    onChange={(e) => {
                                                        setFormCompletado(null);
                                                        const val = e.target.value ? parseInt(e.target.value) : '';
                                                        setFilas((prev) => prev.map((f, i) => i === globalIndex
                                                            ? { ...f, vinculo_destino: val }
                                                            : f));
                                                    }}
                                                >
                                                    <option value="">
                                                        {fila.vinculo_tipo === 'cuelga' ? '(raíz)' : ''}
                                                    </option>
                                                    {(fila.vinculo_tipo === 'cuelga'
                                                        ? getDepartamentosPorEmpresa(globalIndex).filter(d => d.tipo === 'organigrama')
                                                        : filas
                                                            .filter(f => f.tipo === 'organigrama' && f.departamento && f.departamento !== fila.departamento)
                                                            .map(f => departamentosOrganigrama.find(d => d.Id === f.departamento || d.Id.toString() === f.departamento?.toString()))
                                                            .filter(Boolean)
                                                    ).map((departamento) => (
                                                        <option key={departamento.Id} value={departamento.Id}>
                                                            {departamento.nombre}
                                                        </option>
                                                    ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col xs="auto" className="d-flex align-items-center" style={{ paddingTop: '35px' }}>
                                            <Button variant="danger"
                                                onClick={() => eliminarFila(globalIndex)}
                                                style={{ height: '50px', width: '50px' }}>
                                                <Trash2 />
                                            </Button>
                                        </Col>
                                    </Row>
                                );
                            })}

                            {/* ─── Bloque ASESORÍAS ─── */}
                            <TituloSeccion className='mb-12 mt-4'>ASESORÍAS</TituloSeccion>
                            <Col md={2} className="text-center">
                                <Boton
                                    bonificados="true"
                                    grande="true"
                                    as="button"
                                    primario="true"
                                    onClick={(e) => { e.preventDefault(); agregarAsesoria(); }}
                                    form="true"
                                >
                                    + Añadir Asesoría
                                </Boton>
                            </Col>
                            {asesorias.length === 0 && (
                                <p className="text-muted mt-2" style={{ fontStyle: 'italic' }}>
                                    Sin asesorías. Añade una si algún departamento asesora a otro sin colgar
                                    estructuralmente de él.
                                </p>
                            )}
                            {asesorias.map((aRow, aIdx) => {
                                // Opciones = departamentos del negocio (los que aparecen como fila
                                // organigrama con departamento elegido).
                                const opciones = filas
                                    .filter(f => f.tipo === 'organigrama' && f.departamento)
                                    .map(f => departamentosOrganigrama.find(d => d.Id === f.departamento || d.Id.toString() === f.departamento?.toString()))
                                    .filter(Boolean);
                                return (
                                    <Row className="mb-3" key={`as-${aIdx}`}>
                                        <Col md={4}>
                                            <Form.Group>
                                                <TituloCategoria>Departamento asesor {aIdx + 1}</TituloCategoria>
                                                <Form.Select
                                                    className="py-3"
                                                    value={aRow.asesor_de_id || ''}
                                                    onChange={(e) => cambiarAsesoria(aIdx, 'asesor_de_id', e.target.value ? parseInt(e.target.value) : '')}
                                                >
                                                    <option value=""></option>
                                                    {opciones
                                                        .filter(d => !aRow.asesorado_de_id || d.Id !== aRow.asesorado_de_id)
                                                        .map(d => (
                                                            <option key={`asesor-${d.Id}`} value={d.Id}>{d.nombre}</option>
                                                        ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <TituloCategoria>Departamento asesorado {aIdx + 1}</TituloCategoria>
                                                <Form.Select
                                                    className="py-3"
                                                    value={aRow.asesorado_de_id || ''}
                                                    onChange={(e) => cambiarAsesoria(aIdx, 'asesorado_de_id', e.target.value ? parseInt(e.target.value) : '')}
                                                >
                                                    <option value=""></option>
                                                    {opciones
                                                        .filter(d => !aRow.asesor_de_id || d.Id !== aRow.asesor_de_id)
                                                        .map(d => (
                                                            <option key={`asesorado-${d.Id}`} value={d.Id}>{d.nombre}</option>
                                                        ))}
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>
                                        <Col xs="auto" className="d-flex align-items-center" style={{ paddingTop: '35px' }}>
                                            <Button variant="danger"
                                                onClick={() => eliminarAsesoria(aIdx)}
                                                style={{ height: '50px', width: '50px' }}>
                                                <Trash2 />
                                            </Button>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </TabPanel>


                    </Row>


                    <Row className="mt-4">
                        <ContenedorBotones>

                            <Boton
                                bonificados="true"
                                grande="true"
                                as="button"
                                primario="true"
                                type="submit"
                                onClick={handleSubmit}
                                form="true"
                                name='guardar_cambios_statico'
                            >
                                Guardar
                            </Boton>

                            <Boton
                                bonificados="true"
                                grande="true"
                                as="button"
                                primario="true"
                                type="submit"
                                onClick={handleSubmit}
                                form="true"
                            >
                                Guardar y Salir
                            </Boton>
                            <Boton
                                grande="true"
                                to="/gestionpersonas/empresas"
                            >
                                Cancelar
                            </Boton>
                        </ContenedorBotones>
                    </Row>
                </Container>
            </Form>

            {botonRenderClick ? 
                <DatosCorrectosEmpresa envioActivado={formCompletado} />         
                :             
                <DatosCorrectosEmpresa envioActivado={formCompletado} redirect={false} />
            }
            
            <DatosIncorrectos envioActivado={formCompletado} duplicado={errorEnviarForm.negocioDuplicado} />
            <ServerNoCreoEmpresa envioActivado={errorEnviarForm.negocioDuplicado} editar={true} />
        </>
    );
};

const CabeceraForm = styled.div`
    margin: 2% 0% 2% 35%;
`;

const ContenedorBotones = styled.div`
    margin-top: 30%;
`;

const ContenedorEncabezado = styled.div`
    width: 446px !important;
    height: auto !important;
    border: 1px solid #dee2e6;
`

const TituloCategoria = styled(Form.Label)`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 15.6px;
    line-height: 1.8;
    color: #4a4a4a;

    span {
        color: #ff0000;
        font-weight: 400;
    }
`;

const TituloSeccion = styled.h4`
    font-weight: bold;
    font-family: 'Open Sans';
    font-size: 18px;
    margin-top: 30px;
    margin-bottom: 15px;
    color: #2c3e50;
    border-bottom: 2px solid lightgrey;
    padding-bottom: 8px;
    margin-bottom: 25px;
`;


export default FormEditarNegocio